/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_IcInputs */

const cs_sreality_seller_ic = /** @type {(inputs: Sreality_Seller_IcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO (povinné, pokud není zaměstnanec)`)
};

const en_sreality_seller_ic = /** @type {(inputs: Sreality_Seller_IcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO (required if not an employee)`)
};

/**
* | output |
* | --- |
* | "IČO (required if not an employee)" |
*
* @param {Sreality_Seller_IcInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_ic = /** @type {((inputs?: Sreality_Seller_IcInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_IcInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_ic(inputs)
	return cs_sreality_seller_ic(inputs)
});